import {
  postcodeRegex,
  getPostcodeExample,
} from '@/helpers/common';
import {
  POSTCODE_MAX,
  POSTCODE_MIN,
} from '@/inputCharsLimiters/common';

const checkPostcodeStartsWith = (value, startsWith, hasStartsWithValidation = true) => {
  if (!hasStartsWithValidation) return true;
  return value.slice(0, Math.min(value.length, startsWith.length)).split('').every((letter, index) => startsWith[index] === letter.toUpperCase());
};

export default {
  validate: (value, { startsWith = null, required = true, hasStartsWithValidation = true }) => {
    if (!required && !value) {
      return {
        valid: true,
      };
    }

    if (!value || typeof value !== 'string') {
      return {
        required,
        valid: false,
      };
    }

    const noSpaces = value.replace(/ +/g, '');
    const prefix = noSpaces.substr(0, 3);
    const suffix = noSpaces.substr(-3);
    const postcode = `${prefix} ${suffix}`;

    if (
      postcodeRegex.test(postcode) &&
      noSpaces.length >= POSTCODE_MIN &&
      noSpaces.length <= (POSTCODE_MAX - 1) &&
      (/^[A-Z]/i).test(prefix[0]) &&
      (/^[0-9]/).test(suffix[0]) &&
      (/^[A-Z]/i).test(suffix[1]) &&
      (/^[A-Z]/i).test(suffix[2]) &&
      (startsWith ? checkPostcodeStartsWith(postcode, startsWith, hasStartsWithValidation) : true)
    ) {
      return {
        required,
        valid: true,
      };
    }

    return {
      required,
      valid: false,
    };
  },
  message: (fieldName, { _value_: value, startsWith, hasStartsWithValidation }) => {
    const postcodeExample = getPostcodeExample(startsWith);

    const defaultMsg = `Please enter a valid postcode (${postcodeExample}).`;

    if (!value) return defaultMsg;

    const noSpaces = value.replace(/ +/g, '');
    const prefix = noSpaces.substr(0, 3);
    const suffix = noSpaces.substr(-3);
    const postcode = `${prefix} ${suffix}`;

    if (
      startsWith &&
      !checkPostcodeStartsWith(value, startsWith, hasStartsWithValidation)
    ) {
      return `Please enter a ${startsWith} postcode.`;
    }

    if (!(/^[a-zA-Z0-9 ]+$/).test(postcode)) {
      return defaultMsg;
    }

    if (noSpaces.length < 5) {
      return 'Postcode must contain at least 5 characters.';
    }

    if (noSpaces.length > 7) {
      return 'Postcode must contain a maximum of 7 characters.';
    }

    if (!(/^[A-Z]/i).test(prefix[0])) {
      return 'Postcode should start with a letter.';
    }

    if (
      !(/^[0-9]/).test(suffix[0]) ||
      !(/^[A-Z]/i).test(suffix[1]) ||
      !(/^[A-Z]/i).test(suffix[2])
    ) {
      return defaultMsg;
    }

    return defaultMsg;
  },
  params: ['startsWith', 'required', 'hasStartsWithValidation'],
  computesRequired: true,
};
